import React, { useState } from "react";
import Content from "../components/content/Content";
import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/navbar/Navbar";
import { Outlet } from "react-router-dom";
import { ChatProvider } from "../context/ChatContext";
import { ChatModalProvider } from "../components/ChatModal";
import WorkflowContext from "../context/WorkflowContext";
import WorkflowProcessIds from "../constants/WorkflowProcessIdsEnum";
import DBObjectIds from "../constants/DBObjectsIdsEnum";

function DashboardLayout({ children }) {
  const userId = localStorage.getItem("userId") || "";
  const [workflowParams, setWorkflowParams] = useState({
    Workflow: {
      WorkflowProcessId: WorkflowProcessIds.NewRegistration,
      WorkflowStepId: 0,
      DBObjectId: DBObjectIds.StudentFirstRegistrations,
      DBObjectLocationId: 0,
      CreatedBy: userId,
    },
  });

  return (
    <ChatProvider>
      <ChatModalProvider>
        <WorkflowContext.Provider value={{ workflowParams, setWorkflowParams }}>
          <main className="main" id="top">
            <Sidebar />
            <Navbar />
            <Content>
              <Outlet />
            </Content>
          </main>
        </WorkflowContext.Provider>
      </ChatModalProvider>
    </ChatProvider>
  );
}

export default React.memo(DashboardLayout);
